<template lang="pug">
    div
        Modal(
            title="Invite"
            v-model="isInviteLinkModalShow"
        )
            CopyText(:text="invitationLink")
            p(style='word-break: break-all;') Invitation Link: {{ invitationLink }}
        Modal(
            title="Invite user"
            v-model="isModalShow"
            width="460"
            @on-visible-change="handleOnVisibleChange"
        )
            Form(:model="inviteUserForm" ref="inviteUserForm" label-position="left" :label-width="200")
                FormItem(
                    v-for="item in inviteUserFormDataFields"
                    :key="item.key"
                    :prop="item.key"
                    :rules="item.validate"
                )
                    div(slot="label")
                        h3 {{item.title}}
                        .formItemDescription(v-html="item.description")
                    component(
                        :is="item.formRender"
                        v-model="inviteUserForm[item.key]"
                        :formData="inviteUserForm"
                        :formItem="item"
                    )
            div(slot="footer")
                Button(@click="inviteUser" type="primary" long) {{$t('usersmanage.inviteText')}}

        Button(@click="showInviteModal" type="primary") {{$t('usersmanage.inviteText')}}
</template>
<script>
import Vue from "vue";

import { generateInvitationLink } from "@/api/user";

import fieldsData from "@/data/rcmtableFieldsV2";
import FormInput from "./rcmTableFormItems/Input";
import FormSelect from "./rcmTableFormItems/Select/index.js";

import CopyText from "@/components/CopyText";
Vue.component("CopyText", CopyText);

export default {
    name: "InviteUserBtn",
    props: {},
    components: { FormInput, FormSelect },
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {
            isModalShow: false,
            inviteUserForm: {},
            inviteUserFormDataFields: [],
            isInviteLinkModalShow: false,
            invitationToken: "",
            invitationTaskNo: "",
        };
    },
    methods: {
        showInviteModal() {
            this.inviteUserForm = {
                email: "",
                userRoleName: "operator",
            };
            this.isModalShow = true;
        },
        inviteUser() {
            this.$refs.inviteUserForm.validate((valid) => {
                if (!valid) {
                    return this.$Message.error("表單有誤!");
                }
                generateInvitationLink({
                    groupName: this.$store.state.queryGroupName,
                    username: this.inviteUserForm.email,
                    roleName: this.inviteUserForm.userRoleName,
                })
                    .then((res) => {
                        this.isModalShow = false;
                        this.invitationToken = res.data.data.token;
                        this.invitationTaskNo = res.data.data.taskNo;
                        this.isInviteLinkModalShow = true;
                    })
                    .catch((err) => {
                        console.log(err);
                        let errorObject = Object.assign({}, err);
                        if (this.hasBillingPermission) {
                            if (
                                errorObject.response.data.message == "noPlan" ||
                                errorObject.response.data.message == "noCard"
                            ) {
                                // this.$router.push({ name: "Payment", params: { esIndex } });
                                // this.$store.commit("SET_TRIAL_OBJECTNAME", esIndex);
                                // this.$router.push({ name: "Payment" });
                                this.$store.commit("SET_FAIL_PAYMENT_GROUP", errorObject.response.data.groupInfo);
                                this.$store.commit("SET_isPaymentOpened", true);
                            }
                        }
                        this.isModalShow = false;
                    });
            });
        },
        handleOnVisibleChange(visible) {
            if (!visible) {
                this.$refs.inviteUserForm.resetFields();
                this.isModalShow = false;
            }
        },
        hasBillingPermission() {
            return (
                this.$can("read", "billingPermission", "") &&
                // !this.$store.getters.isAdmin &&
                this.$store.state.platformPlan.multiTenancyConfigs.isAllowPaymentShow
            );
        },
    },
    mounted() {
        let inviteUserFormDataFields = fieldsData(this).filter((e) => ["email", "userRoleName"].includes(e.key));
        let emailFieldObj = inviteUserFormDataFields.find((e) => e.key == "email");
        emailFieldObj.description = "The email(username) of the user.";
        emailFieldObj.validate = [
            {
                required: true,
                message: this.$i18n.t("usersmanage.userName") + this.$i18n.t("rcmtable.validateEmptyText"),
                trigger: "blur",
            },
            {
                validator: (rule, value, callback, source, options) => {
                    if (value.indexOf("@") == -1) return callback(new Error("Invalid Email"));
                    if (!/^[a-z0-9\-\_\.\@]*$/.test(value))
                        return callback(
                            new Error(`${this.$i18n.t("rcmtable.validateIllegalCharsPrefix")}: a-z 0-9 - _ . @`)
                        );
                    if (value.length < 6) return callback(new Error(`username too short`));
                    if (value.length > 35)
                        return callback(new Error(`${this.$i18n.t("rcmtable.validateExceedLengthPrefix")}: 35`));
                    callback();
                },
                trigger: "blur",
            },
        ];

        this.inviteUserFormDataFields = inviteUserFormDataFields;
    },
    computed: {
        invitationLink() {
            return `${location.origin}/signup-invite?token=${this.invitationToken}&taskNo=${this.invitationTaskNo}`;
        },
    },
};
</script>
<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/InviteUserBtn.vue